import { FunctionComponent, ReactNode, useId, useMemo, useState } from 'react';
import styles from './styles.module.scss';
import classNames from 'classnames';

export type FacetFilterSectionProps = {
    name: string;
    ariaLabel: string;
    children: Array<ReactNode>;
    numberOfIntiallyVisible: number;
    className?: string;
};

const FacetFilterSection: FunctionComponent<FacetFilterSectionProps> = ({
    name,
    ariaLabel,
    children,
    numberOfIntiallyVisible,
    className,
}) => {
    const id = useId();
    const [showingAll, setShowingAll] = useState(false);
    const hasMoreToShow = useMemo(() => {
        return children.length > numberOfIntiallyVisible;
    }, [children, numberOfIntiallyVisible]);

    return (
        <nav
            className={classNames(styles.FacetFilterSection, className)}
            aria-labelledby={`${id}-heading`}
        >
            <h3 id={`${id}-heading`} aria-label={ariaLabel}>
                {name}
            </h3>
            <ul>
                {children.slice(0, numberOfIntiallyVisible)}
                <li id={`${id}_more`} className={showingAll ? '' : 'screen_reader_hidden'}>
                    <ul>{children.slice(numberOfIntiallyVisible)}</ul>
                </li>
            </ul>
            {hasMoreToShow ? (
                <button
                    onClick={() => setShowingAll(!showingAll)}
                    aria-controls={`${id}_more`}
                    aria-expanded={showingAll}
                >
                    {showingAll ? 'Show less' : 'Show more'}
                </button>
            ) : null}
        </nav>
    );
};

export default FacetFilterSection;
